import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../../product-menu-footer.component';

@Component({
  selector: 'app-plantlife-one-column-empty-footer',
  templateUrl: './plantlife-one-column-empty-footer.component.html',
  styleUrls: ['./plantlife-one-column-empty-footer.component.scss'],
  standalone: false
})
export class PlantlifeOneColumnEmptyFooterComponent extends ProductMenuFooterComponent {}
